export const practicalInformationFields = {
  lastTurnover: "lastTurnover",
  pharmacyArea: "pharmacyArea",
  location: "location",
  frontParking: "frontParking",
  counterScreens: "counterScreens",
  interiorScreens: "interiorScreens",
  showcaseScreens: "showcaseScreens",
}
